import { api } from "@/lib/api";
import { uuid } from "@/interfaces";
import type { Availability, AvailabilityDays } from "@shyne/shared/api";

export const IndividualScheduleRepository = {
  mine(contract: uuid): Promise<Availability> {
    return api.availability.get({ actingOrganization: contract });
  },

  saveMine(contract: uuid, days: AvailabilityDays): Promise<Availability> {
    return api.availability.save({ actingOrganization: contract, days });
  },

  ofWorkerContract(contract: uuid): Promise<Availability> {
    return api.workerContracts.availability(contract);
  },
};
